import warehouseRoutes from './warehouse.route';
import attendanceRoutes from './attendance.route';
import receiptsRoutes from './receipt.route';
import generalRoutes from './general.route';
import foodkidRoutes from './foodkid.route';
import organizationRoutes from './organization.route';
import accountRoutes from './account.route';
import transactionHistoryRoutes from './transaction-history.route';
import settingRoutes from './setting';
import agencyRoutes from './agency.route';
import { IRouteConfig } from '../route.types';
import serviceBookIcon from '@app/assets/images/service-book.svg';
import DashBoard from '@modules/school-service/pages/DashboardPage';

export type { IRouteConfig };

export const schoolServiceModuleRoute: IRouteConfig = {
    icon: serviceBookIcon,
    name: (
        <>
            Dịch vụ <br /> sổ sách bán trú
        </>
    ),
    isMenu: false,
    isRoute: true,
    path: '/so-sach-ban-tru',
    link: '/so-sach-ban-tru',
    exact: true,
    isModule: true,
    themeColor: '#1abcb7',
    main: () => <DashBoard />,
    isAuth: true,
    children: [
        ...agencyRoutes,
        ...organizationRoutes,
        ...accountRoutes,
        ...foodkidRoutes,
        ...warehouseRoutes,
        ...attendanceRoutes,
        ...receiptsRoutes,
        ...generalRoutes,
        ...transactionHistoryRoutes,
        ...settingRoutes,
    ],
};
